import React, { useState, useEffect, useContext } from 'react';

import TimeAndDate from '../../libs/genericFunctions';
import ControllerContext from '../../../../RoomControllerSocketContext';

const Header = () =>
{
	const [ timeData, setTimeData ] = useState(TimeAndDate());
	const { isOnline } = useContext(ControllerContext);

	useEffect(() =>
	{
		const intervalId = setInterval(() =>
		{
			setTimeData(TimeAndDate());
		}, 1000);

		return () => clearInterval(intervalId);
	}, []);

	return (
		<div className='flexRow aCntr desktopPluginPdng desktopPluginTopPdng'>
			<div className='flexMinWidthRow aCntr'>
				{/* <div><img src='/images/meetingroom_logo.svg' alt='' /></div> */}
				<div className='flexAutoRow meetingRoomsLogo'>
					<img src='/images/meetingroom_logo.svg' alt='' className='img' />
				</div>
			</div>
			{!isOnline && <div className='flexAutoRow pdngHLG' style={{ alignSelf: 'flex-start' }}>
				<div className='flexAutoCol'>
					<div className='flexRow blink'>
						<span className='noInternetdot'/>
						<span className='noInternet pdngLSM'>No Internet</span>
					</div>
				</div>
			</div>}
			<div className='flexAutoRow'>
				<div className='flexAutoCol'>
					<div className='flexRow'>
						<span className='datecolour'>{timeData.Date}</span>
					</div>
					<div className='flexRow jCntr'>
						<span className='datecolour jCntr'>{timeData.Time}</span>
					</div>
				</div>
			</div>
		</div>
	);
};

export default Header;
